import * as types from './integration-constants';
import { integrationBlingService } from '../../services/integration-service';

export const integrationBling = data => dispatch => {
  dispatch({
    type: types.INTEGRATION_BLING_REQUEST,
    payload: integrationBlingService(data),
  });
};
